export const extractFields = (data) => {
  const fields = {}
  data?.forEach((field) => {
    fields[field.identifier] = field
  })

  return fields
}
